{
  "fr": {
    "tools_meta": {
      "ai_chat_prefix": "Chat IA",
      "ai_converters_prefix": "Outils multimédia IA",
      "ai_document_qas_prefix": "Discuter avec un PDF",
      "ai_feedbacks_prefix": "Aide à la correction",
      "ai_images_prefix": "Générer une image",
      "ai_mini_tools_prefix": "Laboratoire de prompts",
      "ai_assistants_prefix": "Assistants IA",
      "ai_personas_prefix": "Chatbot jeu de rôle",
      "audio_recorder_prefix": "Enregistrement audio",
      "file_sharing_prefix": "Partager un fichier",
      "link_shortener_prefix": "Raccourcir un lien",
      "pinboard_prefix": "Tableau d'affichage",
      "pupil_feedback_prefix": "Feedback et évaluation IA",
      "qrcodes_prefix": "Créer un QR code",
      "school_class_prefix": "Mes salles de classe",
      "screen_recorder_prefix": "Enregistrement d'écran",
      "surveys_prefix": "Sondage",
      "teaching_board_prefix": "Tableau numérique",
      "text_editor_prefix": "Éditeur de texte",
      "title": "Outils et IA, formations & matériel pédagogique pour enseignant·e·s",
      "video_recorder_prefix": "Enregistrement vidéo",
      "website_prefix": "Site web",
      "word_clouds_prefix": "Nuage de mots",
      "worksheet_prefix": "Fiche d'exercices",
      "curriculum_library_prefix": "Programmes scolaires",
      "to_teach_import_prefix": "Accéder à to teach"
    }
  }
}
